import React, { Fragment, useState, useEffect } from 'react';
import Router from 'next/router';
import { getFaqArticlesBySearch } from 'day8-react/build/content';
import { LoadingView } from 'day8-react';
import {
  ComponentVerticalSpacing,
  ComponentWrapper,
  FaqList,
  Link,
  BREAKPOINTS,
  CardSlider,
  Input,
  Button,
  FormWrap,
  Media
} from 'day8-react/build/new-components';
import { WpPageType } from '../../globalTypes';

export type FaqComponentType = {
  categories: {
    name: string
    slug: string
  }[]
  category?: WpPageType & {
    name: string
  }
  faqs?: []
  searchQuery?: string
}


const FaqComponent = ({
  categories,
  category,
  faqs,
  searchQuery = ''
}: FaqComponentType) => {
  const [searchTerm, setSearchTerm] = useState(searchQuery);
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadedFaqs, setLoadedFaqs] = useState(faqs);
  const [loadedSearchTerm, setLoadedSearchTerm] = useState(searchQuery);
  useEffect(() => {
    const myElement: any = document.getElementsByClassName('active')[0];
    if (myElement && window.innerWidth < BREAKPOINTS.MD) {
      const leftSpace = myElement.offsetLeft;
      setTimeout(() => {
        document.getElementsByClassName('helper__wrapper')[0].scrollTo({ left: leftSpace, top: 20, behavior: 'smooth' });
      }, 2000);
    }
    if (!category || faqs?.length) {
      setIsLoaded(true);
    }
  }, []);
  useEffect(() => {
    setSearchTerm(searchQuery);
    setLoadedSearchTerm(searchQuery);
    setLoadedFaqs(faqs);
    setIsLoaded(true);
  }, [category, searchQuery]);
  const submitForm = (e: React.SyntheticEvent, term: string) => {
    e.preventDefault();
    setIsLoaded(false);
    setLoadedSearchTerm(term);
    if (!term.length) {
      Router.push('/faq').then(() => window.scrollTo(0, 0));
    }
    getFaqArticlesBySearch(term)
      .then(() => {
        Router.push(`/faq/search/${term}`).then(() => window.scrollTo(0, 0));
      }).catch(() => {
        Router.push('/faq').then(() => window.scrollTo(0, 0));
      });
  };
  return (
    <Fragment>
      <ComponentVerticalSpacing noBottom>
        <ComponentWrapper className="text-center">
          <span className="d8-u-color-primary d8-u-ls-sm d8-u-text-bold">All you need to know!</span>
          <h1 className="text-xl">FAQ</h1>
          <div style={{ minHeight: 190 }}>
            {categories && (
              <Fragment>
                <Media lessThan={BREAKPOINTS.MD}>
                  <div
                    id="mobile-faq-container"
                    className={!isLoaded ? 'd8-u-pulse-opacity-animation margin-y-lg' : 'margin-y-lg'}
                    style={{ opacity: !isLoaded ? 0.25 : 1, pointerEvents: !isLoaded ? 'none' : 'inherit' }}
                  >
                    <CardSlider snap>
                      {categories.map(cat => (
                        <Link key={JSON.stringify(cat)} className={`btn btn--ghost ${category?.slug === cat.slug && 'active'}`} href={`/faq/category/${cat.slug}`}>{cat.name}</Link>
                      ))}
                    </CardSlider>
                  </div>
                </Media>
                <Media greaterThanOrEqual={BREAKPOINTS.MD}>
                  <div
                    className={!isLoaded ? 'd8-u-pulse-opacity-animation margin-y-lg' : 'margin-y-lg'}
                    style={{ opacity: !isLoaded ? 0.25 : 1, pointerEvents: !isLoaded ? 'none' : 'inherit' }}
                  >
                    {categories.map(cat => (
                      <Link key={JSON.stringify(cat)} className={`margin-xxs btn btn--ghost ${category?.slug === cat.slug && 'active'}`} href={`/faq/category/${cat.slug}`}>{cat.name}</Link>
                    ))}
                  </div>
                </Media>
              </Fragment>
            )}
          </div>
          <div className="max-width-xs margin-auto text-component">
            <FormWrap onSubmit={(e: React.FormEvent<HTMLInputElement>) => submitForm(e, searchTerm)}>
              <div className="grid grid-gap-md">
                <div className="col-8@md">
                  <Input
                    id="search"
                    type="text"
                    name="search"
                    onChange={(e: React.FormEvent<HTMLInputElement>) => setSearchTerm((e.target as HTMLInputElement).value)}
                    placeholder="Enter search term..."
                    value={searchTerm}
                    labelHidden
                  />
                </div>
                <div className="col-4@md">
                  <Button text={!isLoaded ? 'Searching' : 'Search'} disabled={!isLoaded} type="submit" fullWidth />
                </div>
              </div>
            </FormWrap>
          </div>
        </ComponentWrapper>
      </ComponentVerticalSpacing>
      {!isLoaded && <LoadingView />}
      {categories && loadedFaqs?.length && isLoaded && (
        <FaqList
          categoryTitle={loadedSearchTerm ? `Results for: ${loadedSearchTerm}` : category?.name}
          faqs={loadedFaqs}
        />
      )}
      {!categories || (searchQuery && !loadedFaqs?.length) && isLoaded && <p className="padding-md text-center d8-u-ls-sm d8-u-text-bold">Hm it looks like no FAQs could be found</p>}
    </Fragment>
  );
};

export default FaqComponent;
